/* eslint-disable no-nested-ternary */
/* eslint-disable no-console */
import React, { useState } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { Checkbox, DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import CustomLayout from "../../../../Core/Layout/CustomLayout";
import Button from "../../../../Core/Components/CustomButton";
import { CustomInputWithController } from "../../../../Core/Components/CustomInput";
import AlertIcon from "../../../../Common/Svgs/AlertIcon";
import CalendarIcon from "../../../../Common/Svgs/CalendarIcon";
// import BlockedEyeIcon from "../../../../Common/Svgs/BlockedEyeIcon";
import { client } from "../../../../Utils/axiosClient";
import { editDriverV3 } from "../../../../Redux/APIs/usersAPI";
import { PopoverDropdown } from "../../../../Core/Components/CustomDropdown";
import useHubStationOnAdd from "../../../../Utils/useHubStationOnAdd";
import PhotoUpload from "../PhotoUpload";
import { updateLoggedInUser } from "../../../../Redux/Slices/loggedInUser.slice";
import {
  COUNTRY_CONFIGS,
  DEFAULT_COUNTRY,
} from "../../../../Config/countryConfig";
import {
  parsePhoneNumber,
  getCountryConfigByDialCode,
  validatePhoneNumberLength,
} from "../../../../Utils/phoneNumberHelper";
import DialCodeSelector from "../../../../Core/Components/DialCodeSelector";

// const LicenseUpload = ({
//   url,
//   upload,
//   setUpload,
//   setValue,
//   handleLicenseUpload,
// }) => {
//   if (url) {
//     return (
//       <div className="w-[367px]">
//         <p className="font-aileron font-normal text-xs text-dark-gray mb-1.5">
//           Please upload a PNG/JPEG not more than 2 Mb
//         </p>

//         <div className="flex items-center justify-between">
//           <div className="w-[72px] h-[42px] px-2 border border-green rounded-md">
//             <img
//               src={url}
//               alt="license"
//               className="w-full h-full object-contain"
//             />
//           </div>

//           <button
//             type="button"
//             className="flex items-center justify-end px-2 py-1 mt-3 rounded-md gap-x-2"
//             onClick={() => {
//               setUpload({ loading: false, error: "", progress: 0, name: "" });
//               setValue("licenseUrl", "");
//             }}
//           >
//             <TrashIcon className="text-black" />
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="w-[367px]">
//       <div>
//         <p className="font-aileron font-normal text-xs text-dark-gray mb-1.5">
//           Please upload a PNG/JPEG not more than 2 Mb
//         </p>

//         <Upload
//           customRequest={(options) => handleLicenseUpload(options)}
//           showUploadList={false}
//           maxCount={1}
//           multiple={false}
//           accept="image/png, image/jpeg, image/jpg"
//           disabled={upload?.loading}
//         >
//           <button
//             type="button"
//             className="flex items-center gap-x-2 max-w-max bg-yellow hover:bg-yellow-dark px-4 py-3 rounded-md"
//           >
//             <UploadIcon />
//             <p className="font-poppins font-medium text-xs">Upload</p>
//           </button>
//         </Upload>

//         {upload?.loading ? (
//           <div className="mt-2 flex items-center gap-x-2">
//             <div className="w-[42px] h-[42px] flex items-center justify-center">
//               <Spin
//                 spinning={upload?.loading}
//                 indicator={<LoadingOutlined color="#fad152" />}
//               />
//             </div>

//             <div className="flex-1">
//               <p className="font-poppins font-medium text-xs text-[#000C1E]">
//                 {upload?.name}
//               </p>

//               <div className="mt-1 relative flex-1">
//                 <div
//                   className="absolute z-[20] h-[2px] bg-green rounded-full"
//                   style={{ width: upload?.progress }}
//                 />

//                 <div className="w-full h-[2px] bg-[#DFDFDF] rounded-full" />
//               </div>
//             </div>
//           </div>
//         ) : null}

//         {upload?.error ? (
//           <div className="mt-2 flex items-center gap-x-2">
//             <AlertIcon size={24} className="text-alert-red" />

//             <p className="font-aileron font-normal text-xs text-[#000C1E]">
//               {upload.error}
//             </p>
//           </div>
//         ) : null}
//       </div>
//     </div>
//   );
// };

const LabelAndInput = ({
  label,
  control,
  formState,
  name,
  placeholder,
  rules,
  focus,
  setFocus,
  inputType = "text",
  suffix = null,
  customOnChange = null,
  disabled = false,
  prefix = null,
}) => {
  return (
    <div className="">
      <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
        {label}
      </p>

      <CustomInputWithController
        intent="createUser"
        control={control}
        formState={formState}
        focus={focus}
        setFocus={(e) => setFocus(e)}
        name={name}
        placeholder={placeholder}
        rules={rules}
        inputType={inputType}
        suffix={suffix}
        customOnChange={customOnChange}
        isFieldDisabled={disabled}
        prefix={prefix}
      />
    </div>
  );
};

const AddDriver = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentDriver } = useSelector((state) => state.users);
  const { locationDetails } = useSelector((state) => state.loggedInUser);

  const detectedCountry =
    COUNTRY_CONFIGS.find((c) => c.code === locationDetails?.countryCode) ||
    DEFAULT_COUNTRY;

  const parsedContact = id ? parsePhoneNumber(currentDriver?.contactNo) : null;
  const parsedMpesa = id ? parsePhoneNumber(currentDriver?.mpesaNo) : null;

  const hubStations = useHubStationOnAdd();

  const {
    handleSubmit,
    control,
    formState,
    reset,
    setError,
    setValue,
    clearErrors,
    watch,
    trigger,
    register,
    // getValues,
  } = useForm({
    defaultValues: {
      firstName: id ? currentDriver.firstName : "",
      lastName: id ? currentDriver.lastName : "",
      licenseId: id ? currentDriver.licenseId : "",
      licenseValidity: id
        ? dayjs().isValid(currentDriver.licenseValidity)
          ? dayjs(currentDriver.licenseValidity)
          : null
        : "",
      contactNumberDialCode: id
        ? parsedContact?.dialCode || detectedCountry.dialCode
        : detectedCountry.dialCode,
      contactNumber: id ? parsedContact?.contactNumber || "" : "",
      userId: id ? currentDriver?.appUserId : "",
      email: id ? currentDriver?.email : "",
      // password: "",
      // updatePassword: "",
      hubId: id ? currentDriver?.hubid : null,
      hubName: id ? currentDriver?.hubName : "",
      gender: id ? currentDriver?.gender ?? "male" : "male",
      mpesaNumberDialCode: id
        ? parsedMpesa?.dialCode || detectedCountry.dialCode
        : detectedCountry.dialCode,
      mpesaNumber: id ? parsedMpesa?.contactNumber || "" : "",
      sameNumber: id ? currentDriver?.sameNumber : false,
      licenseUrl: id ? currentDriver?.licenseUrl : "",
    },
  });

  register("contactNumberDialCode");
  register("mpesaNumberDialCode");

  const contactNumberDialCode = watch("contactNumberDialCode") || "+254";
  const contactCountryConfig = getCountryConfigByDialCode(
    contactNumberDialCode,
  );
  const contactPlaceholder =
    contactCountryConfig?.placeholder || "Enter Number";

  const mpesaNumberDialCode = watch("mpesaNumberDialCode") || "+254";
  const mpesaCountryConfig = getCountryConfigByDialCode(mpesaNumberDialCode);
  const mpesaPlaceholder = mpesaCountryConfig?.placeholder || "Enter Number";

  // const [showPassword, setShowPassword] = useState(false);
  const [upload, setUpload] = useState({
    loading: false,
    error: "",
    progress: 0,
    name: "",
  });

  const [focus, setFocus] = useState({
    firstName: false,
    lastName: false,
    licenseId: false,
    contactNumber: false,
    // userId: false,
    email: false,
    // password: false,
    // updatePassword: false,
    mpesaNumber: false,
  });

  const licenseValidityError = formState?.errors?.licenseValidity?.message;
  const hubNameError = formState?.errors?.hubName?.message;

  const rules = { required: "Required." };
  const validationForEmail = {
    required: "please enter email address",
    pattern: {
      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/,
      message: "Enter a vaild email",
    },
  };

  const getGenderStyles = (type = "male") => {
    const current = watch("gender");
    if (type === "male" && current === "male") return "bg-green text-white";
    if (type === "female" && current === "female") return "bg-green text-white";
    return "bg-green-10 text-green hover:bg-green-20";
  };

  const onCancel = () => {
    navigate("/users?tab=drivers");
  };

  const handleLicenseUpload = async (options) => {
    const { onError, onSuccess, file } = options;

    const formData = new FormData();

    formData.append("files", file);
    if (id) formData.append("driverId", id);

    if (file?.size > 2000000) {
      setError((prev) => ({
        ...prev,
        error:
          "File size is too high. Try compressing the image and upload again.",
      }));

      return;
    }

    try {
      setUpload((prev) => ({ ...prev, loading: true, name: file?.name }));

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/drivers/upload-license`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          onUploadProgress: (e) =>
            setUpload((prev) => ({
              ...prev,
              progress: Math.round((e.loaded * 100) / e.total),
            })),
        },
      );

      if (response.status === 200) {
        setValue("licenseUrl", response.data.fileUrl);
        onSuccess(response.data);
      }
    } catch (error) {
      console.log(error);
      onError(error);
    } finally {
      setUpload((prev) => ({
        ...prev,
        loading: false,
        error: "",
        progress: 0,
      }));
    }
  };

  const onAdd = async (e) => {
    const payload = {
      ...e,
      firstName: e.firstName.trim(),
      lastName: e.lastName.trim(),
      licenseId: e.licenseId.trim(),
      contactNumber: `${e.contactNumberDialCode}${e.contactNumber.trim()}`,
      // userId: e.userId.trim(),
      email: e.email?.trim(),
      // password: e.password.trim(),
      // updatePassword: e.updatePassword.trim(),
      mpesaNumber: `${e.mpesaNumberDialCode}${e.mpesaNumber.trim()}`,
      gender: e.gender.trim(),
    };
    delete payload.contactNumberDialCode;
    delete payload.mpesaNumberDialCode;

    if (id) {
      payload.driverId = id;
      await dispatch(editDriverV3(payload));
      reset();
      navigate("/users?tab=drivers");
    } else {
      try {
        const response = await client.post(
          `${process.env.REACT_APP_API_URL}/drivers/add-driver`,
          payload,
        );

        if (response.status === 200) {
          reset();

          dispatch(
            updateLoggedInUser({
              key: "toastMessageModal",
              value: {
                visible: true,
                title: "New Driver Invited",
                description: "1 new driver invited successfully.",
              },
            }),
          );
          navigate("/users?tab=drivers");
        }
      } catch (error) {
        setError(error?.response?.data?.type || "firstName", {
          type: "server",
          message: error.response.data.message,
        });
      }
    }
  };

  return (
    <CustomLayout pageName="Users" hideFooter>
      <div className="px-6 pt-6 bg-background-white">
        <div className="flex items-center justify-between pb-6">
          <p className="font-poppins text-base font-medium capitalize">
            {id ? "Edit Driver" : "Add a new driver"}
          </p>

          <div className="flex items-center gap-x-3">
            <Button
              size="filter"
              width="generateUser"
              colors="grey"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              size="filter"
              width="generateUser"
              type="submit"
              onClick={handleSubmit(onAdd)}
            >
              {id ? "Save" : "Add"} Driver
            </Button>
          </div>
        </div>

        <div className="w-full bg-light-grey h-[1px]" />
      </div>

      <div className="h-[calc(100vh-88px-72px)] bg-background-white p-6 flex flex-col gap-y-6 overflow-y-scroll">
        <LabelAndInput
          label="First Name"
          control={control}
          formState={formState}
          name="firstName"
          placeholder="Enter Name"
          rules={rules}
          focus={focus.firstName}
          setFocus={(state) => setFocus({ ...focus, firstName: state })}
        />

        <LabelAndInput
          label="Last Name"
          control={control}
          formState={formState}
          name="lastName"
          placeholder="Enter Name"
          rules={rules}
          focus={focus.lastName}
          setFocus={(state) => setFocus({ ...focus, lastName: state })}
        />

        <div>
          <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
            Gender
          </p>

          <div className="flex items-center gap-x-2">
            <div
              role="button"
              onClick={() => setValue("gender", "male")}
              className={`h-[34px] px-4 flex items-center rounded-md transform transition-colors duration-200
                ${getGenderStyles("male")}
                `}
            >
              <p className="font-poppins font-medium text-xs">Male</p>
            </div>

            <div
              role="button"
              onClick={() => setValue("gender", "female")}
              className={`h-[34px] px-4 flex items-center rounded-md transform transition-colors duration-200
                ${getGenderStyles("female")}
                `}
            >
              <p className="font-poppins font-medium text-xs">Female</p>
            </div>
          </div>
        </div>

        <LabelAndInput
          label="Contact Number"
          control={control}
          formState={formState}
          name="contactNumber"
          placeholder={contactPlaceholder}
          focus={focus.contactNumber}
          setFocus={(state) => setFocus({ ...focus, contactNumber: state })}
          rules={{
            required: "Required.",
            validate: {
              isNumber: (value) => {
                if (!value) return true;
                return /^\d+$/.test(value) || "Please enter only numbers";
              },
              isValidLength: (value) =>
                validatePhoneNumberLength(value, watch("contactNumberDialCode")),
            },
          }}
          customOnChange={(e) => {
            if (watch("sameNumber")) {
              setValue("mpesaNumber", e);
              clearErrors("mpesaNumber");
            }
          }}
          prefix={
            <DialCodeSelector
              value={watch("contactNumberDialCode")}
              onChange={(val) => {
                setValue("contactNumberDialCode", val);
                if (watch("sameNumber")) {
                  setValue("mpesaNumberDialCode", val);
                }
                trigger("contactNumber");
                if (watch("sameNumber")) {
                  trigger("mpesaNumber");
                }
              }}
            />
          }
        />

        <div>
          <LabelAndInput
            label="Mpesa Number"
            control={control}
            formState={formState}
            name="mpesaNumber"
            placeholder={mpesaPlaceholder}
            focus={focus.mpesaNumber}
            setFocus={(state) => setFocus({ ...focus, mpesaNumber: state })}
            disabled={watch("sameNumber")}
            rules={{
              required: "Required.",
              validate: {
                isNumber: (value) => {
                  if (!value) return true;
                  return /^\d+$/.test(value) || "Please enter only numbers";
                },
                isValidLength: (value) =>
                  validatePhoneNumberLength(value, watch("mpesaNumberDialCode")),
              },
            }}
            prefix={
              <DialCodeSelector
                value={watch("mpesaNumberDialCode")}
                onChange={(val) => {
                  setValue("mpesaNumberDialCode", val);
                  trigger("mpesaNumber");
                }}
                disabled={watch("sameNumber")}
              />
            }
          />

          <div
            role="button"
            className="mt-2 flex items-center gap-x-3 max-w-max"
            onClick={() => {
              const current = watch("sameNumber");
              if (!current) {
                setValue("mpesaNumber", watch("contactNumber"));
                setValue("mpesaNumberDialCode", watch("contactNumberDialCode"));
                clearErrors("mpesaNumber");
              }
              setValue("sameNumber", !current);
            }}
          >
            <Checkbox checked={watch("sameNumber")} />

            <p className="font-aileron font-semibold text-xs text-dark-gray">
              Same As Contact Number
            </p>
          </div>
        </div>

        <div className="">
          <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
            Hub Station
          </p>

          <Controller
            name="hubName"
            control={control}
            rules={rules}
            render={({ field }) => (
              <PopoverDropdown
                {...field}
                enableSearch
                searchPlaceholder="Search Hub Station"
                placeholder="Assign Hub Station"
                className="max-h-[300px] overflow-y-scroll"
                formState={formState}
                options={hubStations}
                onSelect={(data) => {
                  setValue("hubName", data.value);
                  setValue("hubId", data.id);
                  clearErrors("hubName");
                }}
              />
            )}
          />

          <p
            className={`font-poppins text-xs font-light capitalize leading-4.5 mt-2 ${
              hubNameError ? "text-alert-red visible" : "invisible"
            }`}
          >
            {hubNameError}
          </p>
        </div>

        <p className="font-poppins text-xs font-medium pb-2 border-b border-light-grey w-[367px] capitalize">
          License Details
        </p>

        <LabelAndInput
          label="License ID"
          control={control}
          formState={formState}
          name="licenseId"
          placeholder="Enter Number"
          rules={rules}
          focus={focus.licenseId}
          setFocus={(state) => setFocus({ ...focus, licenseId: state })}
        />

        <div>
          <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
            Validity
          </p>

          <Controller
            name="licenseValidity"
            rules={rules}
            control={control}
            render={({ field }) => (
              <DatePicker
                {...field}
                className={`font-aileron text-dark-gray font-semibold text-xs h-10 w-[367px] ${
                  licenseValidityError &&
                  "border border-alert-red hover:border-alert-red"
                }`}
                placeholder="Select Date"
                format="MMM DD, YYYY"
                disabledDate={(current) =>
                  current.isBefore(dayjs().subtract(1, "day"))
                }
                suffixIcon={
                  licenseValidityError ? (
                    <AlertIcon className="text-alert-red" />
                  ) : (
                    <CalendarIcon />
                  )
                }
                allowClear={false}
              />
            )}
          />
          <p
            className={`font-poppins text-xs font-light capitalize leading-4.5 mt-2 ${
              licenseValidityError ? "text-alert-red visible" : "invisible"
            }`}
          >
            {licenseValidityError}
          </p>
        </div>

        <PhotoUpload
          identifier="licenseUrl"
          upload={upload}
          setUpload={setUpload}
          url={watch("licenseUrl")}
          setValue={setValue}
          handleLicenseUpload={handleLicenseUpload}
        />

        {id ? (
          <div>
            <p className="font-aileron text-xs font-normal text-dark-gray capitalize mb-1.5">
              {formState?.defaultValues?.userId ? "User ID" : "Email ID"}
            </p>
            <div className="h-10 w-[367px] bg-background border borer-light-grey rounded-md py-2 px-4 mb-6">
              <p>
                {formState?.defaultValues?.userId ||
                  formState?.defaultValues?.email}
              </p>
            </div>

            {/* <LabelAndInput
              label="Update Password"
              control={control}
              formState={formState}
              name="updatePassword"
              placeholder="Enter new password"
              // rules={rules}
              focus={focus.updatePassword}
              setFocus={(state) =>
                setFocus({ ...focus, updatePassword: state })
              }
              inputType={showPassword ? "text" : "password"}
              suffix={
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <img src="/images/eye.png" className="w-5 h-5" alt="" />
                  ) : (
                    <BlockedEyeIcon className="text-black" />
                  )}
                </button>
              }
            /> */}
          </div>
        ) : (
          <>
            <p className="font-poppins text-xs font-medium pb-2 border-b border-light-grey w-[367px] capitalize">
              Set login credentials For the driver’s mobile app
            </p>

            <LabelAndInput
              label="Email ID"
              control={control}
              formState={formState}
              name="email"
              placeholder="Email ID"
              rules={validationForEmail}
              focus={focus.email}
              setFocus={(state) => setFocus({ ...focus, email: state })}
            />

            {/* <LabelAndInput
              label="Password"
              inputType="password"
              control={control}
              formState={formState}
              name="password"
              placeholder="Enter Password"
              rules={rules}
              focus={focus.password}
              setFocus={(state) => setFocus({ ...focus, password: state })}
            /> */}
          </>
        )}
      </div>
    </CustomLayout>
  );
};

export default AddDriver;
